// ---------------------------------------------------------------------------
// Formatação do submódulo de transferências.
//
// As datas chegam em ISO 8601 UTC (contrato novo, padrão do handoff 0093) — o
// front é quem formata para pt-BR.
// ---------------------------------------------------------------------------

export function formatDateTimeBr(value) {
   if (!value) return '—';
   const date = new Date(value);
   if (Number.isNaN(date.getTime())) return '—';
   return date.toLocaleString('pt-BR');
}

export function formatDateBr(value) {
   if (!value) return '—';
   const date = new Date(value);
   if (Number.isNaN(date.getTime())) return '—';
   return date.toLocaleDateString('pt-BR');
}

export function formatQty(value) {
   if (value === null || value === undefined || value === '') return '—';
   return String(value);
}

// Nome do produto para tabelas que JÁ têm coluna de SKU — repetir o SKU nas
// duas colunas é ruído.
export function productName(item) {
   if (!item) return '—';
   const name = item.prod_name ?? item.prodName;
   if (name) return name;
   const id = item.prod_id ?? item.prodId;
   return id ? `Produto ${id}` : '—';
}

// Rótulo completo "SKU — Nome", para contextos SEM coluna de SKU (cards,
// modais de item). Degrada graciosamente quando falta um dos dois.
export function productLabel(item) {
   if (!item) return '—';
   const sku = item.prod_sku ?? item.prodSku;
   const name = item.prod_name ?? item.prodName;
   if (sku && name) return `${sku} — ${name}`;
   return String(name ?? sku ?? `Produto ${item.prod_id ?? item.prodId ?? ''}`);
}

// Origem → destino, o par que identifica visualmente qualquer transferência.
export function routeLabel(entity) {
   if (!entity) return '—';
   const origin = entity.origin_pdv_name ?? `PDV ${entity.origin_pdv_id ?? '?'}`;
   const dest = entity.dest_pdv_name ?? `PDV ${entity.dest_pdv_id ?? '?'}`;
   return `${origin} → ${dest}`;
}
